// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2oI9F","footer":"ReportModalFilter_footer__1jQsj"};